import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "episode-item-row" }
const _hoisted_2 = { class: "episode-item-row__content" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Lorem ipsum dolor sit amet, consectetur adipisicing elit ")
const _hoisted_4 = { class: "episode-item-row__thumbnail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardDate = _resolveComponent("CardDate")!
  const _component_NThumbnail = _resolveComponent("NThumbnail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CardDate, {
        "model-value": _ctx.item.created_date
      }, null, 8, ["model-value"]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.thumbnail)
        ? (_openBlock(), _createBlock(_component_NThumbnail, {
            key: 0,
            modelValue: _ctx.thumbnail,
            size: "medium"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])
  ]))
}